var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxVectorNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.830078,
    y: 1,
    width: 15,
    height: 15,
    rx: 3.5,
    fill: "#10141B",
    stroke: "#7C868B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxVectorNormal);
export default __webpack_public_path__ + "static/media/checkboxVectorNormal.f50941e3b8c799b6d0790f7fe992def5.svg";
export { ForwardRef as ReactComponent };